import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-second-navigation',
  templateUrl: './second-navigation.component.html',
  styleUrls: ['./second-navigation.component.css']
})
export class SecondNavigationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
